import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/InvoiceReportReqs/InvoiceReportReqs'

function* getInvoiceReport(action) {
    try {
        const result = yield call(req.getInvoiceReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICE_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch invoice report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getInvoiceAgingReport(action) {
    try {
        const result = yield call(req.getInvoiceAgingReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_AGING_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICE_AGING_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch aging report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_AGING_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getInterestReport(action) {
    try {
        const result = yield call(req.getInterestReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INTEREST_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INTEREST_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch interest report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INTEREST_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getReceiptReport(action) {
    try {
        const result = yield call(req.getReceiptReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_RECEIPT_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_RECEIPT_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch receipt report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_RECEIPT_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getCDNoteReport(action) {
    try {
        const result = yield call(req.getCDNoteReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_CD_NOTE_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_CD_NOTE_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch credit/debit note report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CD_NOTE_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getGSTReport(action) {
    try {
        const result = yield call(req.getGSTReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_GST_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_GST_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch GST report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_GST_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getReconciliationReport(action) {
    try {
        const result = yield call(req.getReconciliationReportReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_RECONCILIATION_REPORT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_RECONCILIATION_REPORT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch reconciliation report")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_RECONCILIATION_REPORT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

export default function* InvoiceReportSaga() {
    yield takeLatest(types.GET_INVOICE_REPORT, getInvoiceReport)
    yield takeLatest(types.GET_INVOICE_AGING_REPORT, getInvoiceAgingReport)
    yield takeLatest(types.GET_INTEREST_REPORT, getInterestReport)
    yield takeLatest(types.GET_RECEIPT_REPORT, getReceiptReport)
    yield takeLatest(types.GET_CD_NOTE_REPORT, getCDNoteReport)
    yield takeLatest(types.GET_GST_REPORT, getGSTReport)
    yield takeLatest(types.GET_RECONCILIATION_REPORT, getReconciliationReport)
}
